"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.File = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const react_1 = __importStar(require("react"));
const Box_1 = require("../../Box");
const Label_1 = require("../../Label");
exports.File = react_1.default.forwardRef((props, ref) => {
    const dropArea = react_1.default.useRef(null);
    const [dragging, setDragging] = react_1.default.useState(false);
    const [files, setFiles] = react_1.default.useState(null);
    react_1.useEffect(() => {
        const area = dropArea.current;
        if (!area) {
            return;
        }
        const dragEnter = (e) => {
            var _a;
            e.preventDefault();
            e.stopPropagation();
            if ((_a = e.dataTransfer.items) === null || _a === void 0 ? void 0 : _a[0]) {
                setDragging(true);
            }
        };
        const dragLeave = (e) => {
            e.preventDefault();
            e.stopPropagation();
            setDragging(false);
        };
        const dragOver = (e) => {
            e.preventDefault();
            e.stopPropagation();
            setDragging(true);
        };
        const drop = (e) => {
            var _a;
            e.preventDefault();
            e.stopPropagation();
            setDragging(false);
            if ((_a = e.dataTransfer.files) === null || _a === void 0 ? void 0 : _a[0]) {
                setFiles(e.dataTransfer.files[0]);
            }
        };
        area.addEventListener('dragenter', dragEnter);
        area.addEventListener('dragleave', dragLeave);
        area.addEventListener('dragover', dragOver);
        area.addEventListener('drop', drop);
        return () => {
            if (!area) {
                return;
            }
            area.removeEventListener('dragenter', dragEnter);
            area.removeEventListener('dragleave', dragLeave);
            area.removeEventListener('dragover', dragOver);
            area.removeEventListener('drop', drop);
        };
    }, []);
    const onFilesChanged = react_1.useCallback((event) => {
        var _a;
        if ((_a = event.target.files) === null || _a === void 0 ? void 0 : _a[0]) {
            setFiles(event.target.files);
        }
    }, [setFiles]);
    const filesArray = [];
    if (files !== null) {
        for (var i = 0; i < files.length; i++) {
            filesArray.push(files[i]);
        }
    }
    return (jsx_runtime_1.jsxs(Label_1.Label, Object.assign({ display: "block", textAlign: "center", padding: "1rem", background: "#eee", htmlFor: props.id || '' }, props, { children: [jsx_runtime_1.jsx(Box_1.Box, { as: props => jsx_runtime_1.jsx("input", Object.assign({ type: "file" }, props), void 0), ref: ref, width: "0.1px", height: "0.1px", opacity: 0, overflow: "hidden", position: "absolute", zIndex: -1, onChange: onFilesChanged, id: props.id || undefined }, void 0),
            jsx_runtime_1.jsxs(Box_1.Box, Object.assign({ padding: "1rem", border: "4px dashed transparent", borderRadius: "5px", borderColor: dragging ? 'accent' : 'primary', ref: dropArea }, { children: [filesArray.map(file => {
                        return file.name;
                    }), jsx_runtime_1.jsxs(Box_1.Box, { children: [jsx_runtime_1.jsx("span", Object.assign({ style: { fontSize: '3rem' } }, { children: jsx_runtime_1.jsx(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faCloudUploadAlt }, void 0) }), void 0),
                            jsx_runtime_1.jsx(Box_1.Box, Object.assign({ as: "span", fontSize: "0.8rem", color: "#555" }, { children: "Drop your files here, or" }), void 0),
                            jsx_runtime_1.jsx(Box_1.Box, Object.assign({ background: "#ccc", padding: "0.5rem", width: "fit-content", marginX: "auto", marginTop: "0.5rem" }, { children: "Browse files" }), void 0)] }, void 0)] }), void 0)] }), void 0));
});
//# sourceMappingURL=index.js.map